import { render, staticRenderFns } from "./GpsAccessList.vue?vue&type=template&id=6b5019ba&"
import script from "./GpsAccessList.vue?vue&type=script&lang=js&"
export * from "./GpsAccessList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports